import React from 'react';
import { View } from 'react-native';

import { TextPropTypes } from 'deprecated-react-native-prop-types';
import { map as _map } from 'lodash';
import PropTypes from 'prop-types';

import { VFText } from '@vfgroup-oneplatform/foundation/Components';
import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import styles from './ShowMoreContent.Styles.js';

const ShowMoreContent = ({ showContent, content, labelStyle, valueStyle }) => {
  const { description, data } = content || {};
  const theme = useTheme();

  if (!showContent) {
    return null;
  }

  return (
    <>
      <View style={styles.divider(theme)} />
      <VFText i18nKey={description} style={styles.description} />
      {_map(data, ({ label, value }) => (
        <View style={styles.itemWrapper(theme)}>
          <VFText i18nKey={label} style={[styles.itemText, labelStyle]} />
          <VFText i18nKey={value} style={[styles.itemText, valueStyle]} />
        </View>
      ))}
    </>
  );
};

ShowMoreContent.propTypes = {
  showContent: PropTypes.bool,
  content: PropTypes.shape({
    description: PropTypes.string,
    data: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        value: PropTypes.string,
      }),
    ),
  }),
  labelStyle: TextPropTypes.style,
  valueStyle: TextPropTypes.style,
};

export default ShowMoreContent;
